import {OnboardingStyle} from "@components/onboarding/onboarding.style";
import {createStyles, Theme} from "@material-ui/core";

export const AddCoparentStyles = (theme: Theme) => createStyles({
    ...OnboardingStyle(theme),
});



// WEBPACK FOOTER //
// ./src/components/onboarding/steps/StepAddCoparent/addCoparent.styles.ts